import styled from "styled-components";
import LoadingButton from "../../loadingButton/loadingButton.component";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 10px;
  padding: 2rem;
  width: min(95vw, 600px);
  min-height: 300px;
  justify-content: space-between;
`;
export const ModalTitle = styled.h1`
  margin-bottom: 2rem;
`;
export const ModalMessage = styled.p``;
export const ConfirmButton = styled(LoadingButton)<{ disabled: boolean }>`
  color: ${({ theme: { colors } }) => colors.white};
  padding: 0.5rem 3rem;
`;
export const CancelButton = styled.button`
  padding: 0.5rem 3rem;
  border: 1px solid ${({ theme: { colors } }) => colors.black};
`;
